import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { useCarrotPartnerBookingApiClient } from "./useCarrotPartnerBookingApiClient"
import ResponseError from "../types/ResponseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"

const HEALTH_INSURANCE_OPTIONS_QUERY_KEY = "healthInsuranceOptions"

export function useHealthInsuranceOptions(): UseQueryResult<string[], ResponseError> {
  const client = useCarrotPartnerBookingApiClient()

  return useQuery<string[], ResponseError>(
    [HEALTH_INSURANCE_OPTIONS_QUERY_KEY],
    () => client.getHealthInsuranceOptions(),
    {
      // Health insurance options don't change frequently, so we can cache for a reasonable time
      staleTime: 30 * 60 * 1000, // 30 minutes - data is considered fresh for half an hour
      cacheTime: 2 * 60 * 60 * 1000, // 2 hours - keep in memory for 2 hours

      refetchOnWindowFocus: false,
      retry: buildCarrotApiRetryPolicy(3)
    }
  )
}
